import { useQuery } from "@tanstack/react-query";

import { casesApi } from "../lib/api";
import { creatableTaskTypes, useScopeTaskTypes } from "../tasks";

/** The case in view, the task types a person may create on it, and whether it is finalized. */
export const useCaseTaskTypes = (
  caseNumber: number,
  enabled: boolean,
  canCreatePrimary: boolean,
) => {
  const { data: kase } = useQuery({
    queryKey: ["cases", caseNumber],
    queryFn: () => casesApi.getCase(caseNumber),
    enabled,
  });
  const scopeTaskTypes = useScopeTaskTypes(enabled ? kase?.caseType : undefined);
  const isFinalized = kase?.step === "finalized";
  const taskTypes =
    enabled && kase && scopeTaskTypes.data
      ? creatableTaskTypes(scopeTaskTypes.data, kase.step, canCreatePrimary)
      : [];
  return { kase, taskTypes, isFinalized };
};
